import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { AsyncPipe } from '@angular/common';
import { EventSystemActions } from '../../data-services/stores/actions/event-system.actions';
import { RouterModule } from '@angular/router';
import { StepperModule } from 'primeng/stepper';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PasswordModule } from 'primeng/password';
import { UserRegistration } from '../../data-services/models/auth/user-registration.model';
import { InputTextModule } from 'primeng/inputtext';
import { DatePickerModule } from 'primeng/datepicker';
import { MessageModule } from 'primeng/message';
import { AuthService } from '../../data-services/auth.service';
import { FocusOnShowDirective } from '../../data-services/directives/focus-select.directive';
import { RecaptchaModule, RecaptchaV3Module, ReCaptchaV3Service } from 'ng-recaptcha-2';
import { environment } from '../../../environments/environment';
import { selectAllEventSystems } from '../../data-services/stores/selectors/event-systems.selectors';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-auth-register',
    imports: [AsyncPipe,RouterModule,StepperModule,FormsModule,ReactiveFormsModule,PasswordModule,InputTextModule,DatePickerModule,MessageModule,FocusOnShowDirective,RecaptchaModule,RecaptchaV3Module],
    templateUrl: '../ui/register.component.html',
    styleUrl: '../ui/register.component.css',
})
export class RegisterComponent implements OnInit{
    private readonly _store = inject(Store);
    private readonly _authService = inject(AuthService);
    private readonly _recaptcha = inject(ReCaptchaV3Service);
    private readonly _titleService = inject(Title)

    recaptchaKey: string = '6LcDm2kpAAAAAH4rSLWeH8nX3qB0EgVtY3t_lN4B';
    eventSystems$ = this._store.select(selectAllEventSystems);
    registrationUser: UserRegistration = {
        email: '',
        password: '',
        confirmPassword: '',
        firstname: '',
        surname: '',
        dob: new Date(new Date().setFullYear(1990)),
        displayBookings: false,
        recaptcha: ''
    }

    get registrationEnabled(): boolean {
        return this.registrationUser.email !== ''
            && this.registrationUser.password !== ''
            && this.registrationUser.password === this.registrationUser.confirmPassword;
    }

    get legalStuffEnabled(): boolean {
        return this.registrationUser.firstname !== '' && this.registrationUser.surname !== '' && this.registrationUser.dob !== null;
    }

    ngOnInit(): void {
        this._store.dispatch(EventSystemActions.loadEventSystems());
        this._titleService.setTitle('LRPTickets.co.uk | Create an account')
    }

    register() {
        this._recaptcha.execute('importantAction')
            .subscribe((token) => {
                this.registrationUser.recaptcha = token;
                this._authService.register(this.registrationUser);
            })
        
    }
}
